<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/j_teaser.png">
  </div>
</template>

<script>
export default {
  name: 'Home',
}
</script>

<style scoped>
.home {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -129px;
  margin-left: -226px;
}
</style>